import {XhrService} from "../ts/xhr.service";
import {appendScriptToDOM} from "./utilities/functions";
import {addErrorClass, addLoadingClass, addSuccessClass} from "./utilities/updateClasses";
import {updateItemlistStickyOrderBarCount} from "./itemlistStickyOrderBar";
import {closeModal, showModal} from "./modal";
import {updateHeaderBasket} from "./basket";
import {initializeCustomSearchRadio} from "../../../koch-chemie-b2c/src/js/custom/selectWithSearch";
import {initInputBody} from "./inputfile";
import {focusInputGroups} from "./checkInputGroups";

async function setIndividualizationPrice(selectedColor) {
    let colorPriceData = await getItemPrice(selectedColor);
    let colorPrice = colorPriceData.customer_price.trim();
    const div = document.createElement('div');
    div.innerHTML = colorPriceData.fundamentalPrice.trim();
    let parentPrice = div.querySelector('.priceNotice');
    if(parentPrice) {
        parentPrice = parentPrice.textContent.trim() + ' · ';
    } else {
        parentPrice = '';
    }

        document.querySelector(".individualizationPriceWrapper").style.display = "flex";
    document.getElementById('individualization_price_price').innerText = colorPrice;
    document.getElementById('individualization_price_notice').innerHTML = colorPriceData.vatInfo;
    let priceNotice = document.getElementById('individualization_price_notice').querySelector('.priceNotice');
    priceNotice.innerHTML = parentPrice  + priceNotice.innerHTML;
}

export async function initButtonsForIndividualization() {
    let colorSelector = document.getElementsByClassName('color-selector-select');
    let orderNowButton = document.getElementById('add_individualization_to_basket');

    // Function to update button state based on selection validity
    const updateIndividualizationButtonState = () => {
        if (!orderNowButton) return;

        if (!orderNowButton.hasAttribute('data-original-text')) {
            const basketIcon = orderNowButton.querySelector('.icon-basket-add');
            const textNode = Array.from(orderNowButton.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
            if (textNode) {
                orderNowButton.setAttribute('data-original-text', textNode.textContent.trim());
            }
        }

        // Check if button was initially disabled due to item availability
        // This attribute is set by the backend and should never be overridden
        const isInitiallyDisabled = orderNowButton.hasAttribute('data-initially-disabled') ||
                                      orderNowButton.getAttribute('disabled') === 'disabled';

        if (isInitiallyDisabled && !orderNowButton.hasAttribute('data-initially-disabled')) {
            orderNowButton.setAttribute('data-initially-disabled', 'true');
        }

        // If item is not available, keep button disabled regardless of selection
        if (isInitiallyDisabled) {
            orderNowButton.disabled = true;
            orderNowButton.classList.add('disabled');
            return;
        }

        const visibleColorSelector = getRenderedColorSelector(colorSelector);

        const basketIcon = orderNowButton.querySelector('.icon-basket-add');
        const originalText = orderNowButton.getAttribute('data-original-text') || GLOBALS.tc.add_to_basket;
        const notAvailableText = GLOBALS.tc.not_available;

        if (!visibleColorSelector) {
            orderNowButton.disabled = true;
            orderNowButton.classList.add('disabled');
            const textNode = Array.from(orderNowButton.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
            if (textNode) {
                textNode.textContent = notAvailableText;
            }
            return;
        }

        const selectedOption = getSelectedColorOption(visibleColorSelector);
        const code = selectedOption?.getAttribute('code');
        const itemId = selectedOption?.getAttribute('item_id');

        // Disable button if no valid selection (disabled options or missing attributes)
        if (!code || !itemId || selectedOption?.disabled) {
            orderNowButton.disabled = true;
            orderNowButton.classList.add('disabled');
            const textNode = Array.from(orderNowButton.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
            if (textNode) {
                textNode.textContent = notAvailableText;
            }
        } else {
            orderNowButton.disabled = false;
            orderNowButton.classList.remove('disabled');
            const textNode = Array.from(orderNowButton.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
            if (textNode) {
                textNode.textContent = originalText;
            }
        }
    };

    let btnStandard = document.getElementById('individualization_standard');

    if (btnStandard) {
        btnStandard.classList.add('selected');
        showOneOfBodys('standard');
        btnStandard.addEventListener('click', function (event) {
            buttons.forEach(btn => btn.classList.remove("selected"));
            btnStandard.classList.add("selected");
            showOneOfBodys('standard');
            updateIndividualizationButtonState();
        });
    }

    let btnSpecial = document.getElementById('individualization_special');

    if (btnSpecial) {
        btnSpecial.addEventListener('click', function (event) {
            buttons.forEach(btn => btn.classList.remove("selected"));
            btnSpecial.classList.add("selected");
            showOneOfBodys('special');
            updateIndividualizationButtonState();
        });
    }

    let btnRalColor = document.getElementById('individualization_ral_color');

    if (btnRalColor) {
        btnRalColor.addEventListener('click', function (event) {
            buttons.forEach(btn => btn.classList.remove("selected"));
            btnRalColor.classList.add("selected");
            showOneOfBodys('ral_color');
            updateIndividualizationButtonState();
        });
    }

    let btnOwnPattern = document.getElementById('individualization_own_pattern');

    if (btnOwnPattern) {
        btnOwnPattern.addEventListener('click', function (event) {
            buttons.forEach(btn => btn.classList.remove("selected"));
            btnOwnPattern.classList.add("selected");
            showOneOfBodys('own_pattern');
            updateIndividualizationButtonState();
        });
    }

    if (colorSelector.length > 0) {
        let lock = false;

        Array.from(colorSelector).forEach(selector => {
            selector.addEventListener('change', async function (event) {
                if (lock) {
                    event.stopImmediatePropagation();
                    return;
                }
                const selectedOption = getSelectedColorOption(selector);
                if (!selectedOption || !selectedOption.value) {
                    return;
                }

                lock = true;
                setIndividualizationPrice(selectedOption.value).finally(() => {
                    setTimeout(() => lock = false, 50);
                });
            }, true);
        });
    }

    let itemQty = document.getElementById('item_qty');
    let isAddingIndividualization = false; // Prevent race conditions

    // Add change listeners to color selectors to update button state
    if (colorSelector && colorSelector.length > 0) {
        Array.from(colorSelector).forEach(selector => {
            if (selector instanceof Element) {
                selector.addEventListener('change', updateIndividualizationButtonState);
            }
        });
    }

    // Initial button state update
    updateIndividualizationButtonState();

    if(itemQty) {
        itemQty.addEventListener('change', async function (event) {
            orderNowButton.disabled = itemQty.value < 1;
        });
    }

    if (orderNowButton && itemQty) {
        orderNowButton.addEventListener('click', async function (event) {
            let orderButtonWrapper = event.target.closest('.orderButtonWrapper');
            let quantityInput = orderButtonWrapper.querySelector('.js-quantity-value');
            // Prevent default form submission and stop event propagation
            event.preventDefault();
            event.stopPropagation();

            // Prevent race conditions from multiple clicks
            if (isAddingIndividualization) {
                return;
            }

            // Prevent action if button is disabled
            if (orderNowButton.disabled) {
                return;
            }

            const visibleColorSelector = getRenderedColorSelector(colorSelector);

            if (!visibleColorSelector) {
                console.error('No visible color selector found');
                return;
            }

            // Read the selection from the same source as updateIndividualizationButtonState
            // (the native selectedIndex), NOT via querySelector('option[selected]'). The custom
            // dropdown widget only sets that attribute on a direct item click, so it can be
            // missing even though a color is selected, which caused an uncaught TypeError here.
            const selectedOption = getSelectedColorOption(visibleColorSelector);
            const code = selectedOption?.getAttribute('code');
            const itemId = selectedOption?.getAttribute('item_id');

            if (!code || !itemId) {
                console.error('Invalid selection: missing code or itemId');
                return;
            }

            isAddingIndividualization = true;
            try {
                await addIndividualizationItemToBasket(itemId, code, quantityInput.value, orderNowButton);
            } catch (e) {
                console.error('Error adding individualization to basket:', e);
            } finally {
                isAddingIndividualization = false;
            }
        });
    }

    const buttons = document.querySelectorAll(".selecting_individualization_type_body button");


    const itemCard = document.querySelector('.itemcard');
    const individualizationModal = document.querySelector('.individualizationModal');

    if (itemCard && individualizationModal) {
        const categoryColor = getComputedStyle(itemCard).getPropertyValue('--category-color').trim();

        if (categoryColor) {
            individualizationModal.style.setProperty('--category-color', categoryColor);

            // Convert the color to RGB if it's in hex format
            const rgb = categoryColor.match(/\d+/g) ?
                categoryColor.match(/\d+/g).map(Number) :
                hexToRgb(categoryColor);

            if (rgb) {
                const [r, g, b] = rgb;
                const lightness = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

                let adjustedColor;
                const contrastThreshold = 0.3; // Equivalent to 30%

                if (lightness > contrastThreshold) {
                    adjustedColor = mixColors(rgb, [0, 0, 0], 0.6); // Mix with black
                } else {
                    adjustedColor = mixColors(rgb, [255, 255, 255], 0.6); // Mix with white
                }

                individualizationModal.style.setProperty('--adjusted-color', `rgb(${adjustedColor.join(",")})`);
            }
        }
    }

    function hexToRgb(hex) {
        const bigint = parseInt(hex.slice(1), 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return [r, g, b];
    }

    function mixColors(color1, color2, weight) {
        return color1.map((val, index) => Math.round(val * (1 - weight) + color2[index] * weight));
    }

    if (itemCard && individualizationModal) {
        const categoryColor = getComputedStyle(itemCard).getPropertyValue('--category-color').trim();

        if (categoryColor) {
            individualizationModal.style.setProperty('--category-color', categoryColor);

            const rgb = categoryColor.match(/\d+/g) ?
                categoryColor.match(/\d+/g).map(Number) :
                hexToRgb(categoryColor);

            if (rgb) {
                const [r, g, b] = rgb;
                const lightness = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

                let adjustedColor;
                const contrastThreshold = 0.3;

                if (lightness > contrastThreshold) {
                    adjustedColor = mixColors(rgb, [0, 0, 0], 0.6);
                } else {
                    adjustedColor = mixColors(rgb, [255, 255, 255], 0.6);
                }

                individualizationModal.style.setProperty('--adjusted-color', `rgb(${adjustedColor.join(",")})`);
            }
        }
    }

    initializeCustomSearchRadio();


    const modalHeader = document.querySelector(".individualizationModalHeader");
    if (modalHeader){
        const closeButton = modalHeader.querySelector('.modal__close');
        const modalDialog = document.querySelector(".modal__dialog:has(.individualizationModal)");
        if (modalDialog && closeButton){
            modalDialog.addEventListener('scroll', () => {
                if (modalDialog.scrollTop > 0) {
                    closeButton.classList.add('is-sticky');
                } else {
                    closeButton.classList.remove('is-sticky');
                }
            });
        }
    }

    await selectCorrectItemBasedOnUrl();
}

export async function selectCorrectItemBasedOnUrl(){
    let urlParams = new URLSearchParams(window.location.search);

    if(urlParams.has('individualization')){
        let btnStandard = document.getElementById('individualization_standard');

        if(btnStandard) {
            btnStandard.classList.remove('selected');
        }

        let selectionType = 'special';
        let colorClass = 'special-color';
        const colorOption = document.querySelector('.customSelect__hiddenFormField option[code="' + urlParams.get('individualization')+ '"]');
        if(colorOption === null) {
            return;
        }
        const parentWithId = colorOption.closest('[id^="modal_body_"]');
        if (parentWithId) {
            const value = parentWithId.id.replace("modal_body_", "");
            selectionType = value;
            colorClass = value + '-color';
            if(value === 'ral') {
                selectionType = 'ral_color';
                colorClass = 'rai-color';
            } else if(value === 'own_pattern') {
                colorClass = 'own-pattern';
            }
        }

        showOneOfBodys(selectionType);
        let individualizationButton = document.getElementById('individualization_' + selectionType);

        if (individualizationButton) {
            individualizationButton.classList.add('selected');
        }

        let colorSelector = document.getElementsByClassName(colorClass);
        if(colorSelector.length === 0){
            return;
        }

        let code = urlParams.get('individualization');
        code = code.toLowerCase();
        let visibleColorSelector = colorSelector[0];
        let matchedOption = null;

        for (let i = 0; i < visibleColorSelector.options.length; i++) {
            const optionCode = visibleColorSelector.options[i].getAttribute('code') || '';
            if (optionCode.toLowerCase() === code) {
                visibleColorSelector.selectedIndex = i;
                matchedOption = visibleColorSelector.options[i];
                matchedOption.setAttribute('selected', true);

                await setIndividualizationPrice(matchedOption.value);
                break;
            }
        }

        // Without a match the select still points at the first option, which is a group
        // heading — writing that into the trigger would replace the "please select" hint.
        if (!matchedOption) {
            return;
        }

        let textDiv = visibleColorSelector.parentElement.getElementsByClassName('customSelect__selected')[0];
        if (textDiv) {
            textDiv.innerText = matchedOption.innerText;
        }
    }

}

function showOneOfBodys(bodyName) {
    let modalBodyStandard = document.getElementById('modal_body_standard');
    if (modalBodyStandard) {
        modalBodyStandard.style.display = 'none';
    }

    if (modalBodyStandard && bodyName === 'standard') {
        modalBodyStandard.style.display = 'block';
    }

    let modalBodySpecial = document.getElementById('modal_body_special');
    if (modalBodySpecial) {
        modalBodySpecial.style.display = 'none';
    }

    if (modalBodySpecial && bodyName === 'special') {
        modalBodySpecial.style.display = 'block';
    }

    let modalBodyRAL = document.getElementById('modal_body_ral');
    if (modalBodyRAL) {
        modalBodyRAL.style.display = 'none';
    }

    if (modalBodyRAL && bodyName === 'ral_color') {
        modalBodyRAL.style.display = 'block';
    }

    let modalBodyOwnPattern = document.getElementById('modal_body_own_pattern');
    if (modalBodyOwnPattern) {
        modalBodyOwnPattern.style.display = 'none';
    }

    if (modalBodyOwnPattern && bodyName === 'own_pattern') {
        modalBodyOwnPattern.style.display = 'block';
    }
}

async function getItemPrice(item_no){

    let response = await fetch('/module/dcshop/GeneralAjaxData.php?function=getItemPrice&item_no=' + item_no + '&language=' + document.body.dataset.lang_code + '&site=' + document.body.dataset.site_code, {
        method: 'GET',
    });

    if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
    }

    const json = await response.json();

    return json;
}

async function addIndividualizationItemToBasket(itemId, code, itemsQty, target) {
    let formData = new FormData();
    formData.append('item_id', itemId);
    formData.append('item_var_code', code);
    formData.append('item_qty', itemsQty);
    formData.append('action', 'shop_add_item_to_basket_card');
    let fn = 'cart';

    return XhrService.generalAjaxCall(fn, formData, 'POST', 'json').then(response => {
        if (!response.status) {
            throw new Error("Could not save data");
        }

        const headerBasket = document.querySelector('.js-headerBasket');
        if (headerBasket) {
            if (response.headerBasketContent) {
                var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                updateHeaderBasket(doc);
            } else {
                console.warn('addIndividualizationItemToBasket: headerBasketContent is missing in response');
            }
        }
        if (response.tagManager) {
            appendScriptToDOM(response.tagManager, true);
        }

        addSuccessClass(target, () => {
            let existingModal = document.getElementById('modalUserQueue');
            if (existingModal) {
                closeModal(existingModal);
            }
        });

        return response;
    }).catch((e) => {
        addErrorClass(target);
        console.error('addIndividualizationItemToBasket error:', e);
        throw e; // Re-throw to allow caller to handle the error
    });
}

/**
 * Checks whether an element is currently rendered, i.e. not inside a `display: none` subtree.
 *
 * Only one of the four individualization bodies is displayed at a time, so "is rendered" is
 * exactly the criterion needed to find the active color selector. It deliberately does NOT
 * hit-test via `document.elementFromPoint()`: that additionally requires the element to lie
 * inside the viewport, which on mobile is regularly not the case because the modal is taller
 * than the screen. `elementFromPoint()` then returns null and the old implementation dereferenced
 * that null, throwing a TypeError out of initButtonsForIndividualization().
 */
function isRendered(elem) {
    if (!(elem instanceof Element)) return false;
    if (elem.getClientRects().length === 0) return false;

    const style = getComputedStyle(elem);
    if (style.visibility !== 'visible') return false;

    return parseFloat(style.opacity) >= 0.1;
}

/**
 * Returns the color select of the individualization type that is currently displayed, or null.
 * The selects themselves are `display: none` (they are replaced by the custom dropdown widget),
 * so the wrapping `.customSelect` element is checked instead.
 */
function getRenderedColorSelector(colorSelectors) {
    return Array.from(colorSelectors).find(selector => isRendered(selector.parentElement)) || null;
}

/**
 * Returns the selected option of a color select, or null when nothing is selected.
 * Group headings are rendered as options without `code`/`item_id`, so callers still have to
 * validate those attributes before using the option.
 */
function getSelectedColorOption(colorSelect) {
    if (!colorSelect || colorSelect.selectedIndex < 0) {
        return null;
    }

    return colorSelect.options[colorSelect.selectedIndex] || null;
}

export function checkIfIndividualizationCanBeApplied(){
    let urlParams = new URLSearchParams(window.location.search);

    if(urlParams.has('individualization')) {
        let targets = document.getElementsByClassName("js-addToBasketItemcard");

        if (targets.length === 0) {
            return;
        }

        let target = targets[0];

        if (target.closest(".js-addToBasketItemcard")) {
            target = target.closest(".js-addToBasketItemcard");
            let form = target.closest("form");
            let orderButtonWrapper = target.closest(".orderButtonWrapper");
            let quantityInput = orderButtonWrapper.querySelector('.js-quantity-value');
            let customizableInputValue = form.dataset.customized;
            let quantityValue = 0;

            if ((form && quantityInput) || (form && customizableInputValue === '1'))  {
                if (quantityInput) {
                    quantityValue = quantityInput.value;
                }
                if (quantityValue > 0 || customizableInputValue === '1') {
                    addLoadingClass(target);
                    let formData = new FormData(form);
                    let action = form.dataset.action;
                    formData.set('action', action);

                    // Validate required fields for cartCustomize
                    const actionId = formData.get('action_id');
                    if (!actionId) {
                        console.error('checkIfIndividualizationCanBeApplied: action_id is missing');
                        console.error('Form data:', Array.from(formData.entries()));
                        addErrorClass(target);
                        return;
                    }

                    XhrService.generalAjaxCall('cartCustomize', formData, 'POST', 'json').then(response => {
                        if (!response.status) {
                            throw new Error("Could not save data");
                        }

                        // Only add success class after confirming the response is valid
                        addSuccessClass(target);

                        let existingModal = document.getElementById('modalUserQueue');
                        if (existingModal) {
                            existingModal.remove();
                        }

                        const parser = new DOMParser();
                        const customizeModalParser = parser.parseFromString(response.customizeModal, 'text/html');
                        const customizeModal = customizeModalParser.querySelector('.modal');

                        if(customizeModal){
                            document.body.appendChild(customizeModal);
                            initInputBody(customizeModal.querySelectorAll(".fileBody"));
                            focusInputGroups(customizeModal.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
                            showModal(customizeModal);
                            initButtonsForIndividualization();
                        }
                    }).catch((e) => {
                        addErrorClass(target);
                        console.error('checkIfIndividualizationCanBeApplied error:', e);
                    });
                }
            }
        }
    }
}